import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../../shared/shared.module";
import { IconsModule } from "../../icons/icons.module";
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { ServiceErrorComponent } from './service-error.component';
import { ServiceErrorRoutingModule } from './service-error-routing.module';


@NgModule({
  declarations: [
    ServiceErrorComponent
  ],
  imports: [
    CommonModule,
    ServiceErrorRoutingModule,
    SharedModule,
    IconsModule,
    ToolbarModule
  ]
})
export class ServiceErrorModule { }
